import { render, staticRenderFns } from "./ModalBulkUpdate.vue?vue&type=template&id=e5873c3e&"
import script from "./ModalBulkUpdate.vue?vue&type=script&lang=js&"
export * from "./ModalBulkUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports